export default {
  UPDATE_UNREAD_NOTIFICATION_COUNT: 'UPDATE_UNREAD_NOTIFICATION_COUNT',
}
